<div class="image-carousel" *ngIf="images.length > 0">
  <div class="row">
    <div
      *ngIf="images.length > 1 && images.length < 5"
      class="col-lg-2 thumb-pagination"
    >
      <ng-container *ngFor="let image of images; let i = index">
        <ng-container
          *ngIf="
            [image]
              | productImageURL
                : settingNames.ProductImageLarge as productImageURL
          "
        >
          <img
            class="image-carousel-side-image img-fluid"
            [src]="productImageURL"
            [alt]="productImageURL | productImageAlt"
            [class.active]="activeImage === i"
            (click)="handleClick(i)"
            vwProductImageFallback
          />
        </ng-container>
      </ng-container>
    </div>

    <div
      [class.col-lg-10]="images.length > 1"
      [class.col-lg-12]="images.length === 1"
    >
      <div class="image-carousel-main">
        <span *ngFor="let pm of productMessages" class="product-message">{{
          pm
        }}</span>
        <i
          class="fal fa-chevron-left round-bg side-arrow side-arrow-left"
          *ngIf="images.length > 1"
          (click)="prev()"
        ></i>
        <i
          class="fal fa-chevron-right round-bg side-arrow side-arrow-right"
          *ngIf="images.length > 1"
          (click)="next()"
        ></i>

        <ng-container
          *ngIf="
            [images[activeImage]]
              | productImageURL
                : settingNames.ProductImageLarge as productImageURL
          "
        >
          <img
            class="img-fluid"
            (click)="toggleLightbox()"
            [src]="productImageURL"
            [alt]="productImageURL | productImageAlt"
            vwProductImageFallback
          />
        </ng-container>
      </div>
      <div *ngIf="images.length > 1" class="row">
        <div class="col-12 image-carousel-paging-info mt-2">
          <span>
            {{
              "imageCarousel.pictureXOfY"
                | translate: { x: activeImage + 1, y: images.length }
            }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <!-- the lightbox could be in a separate component. but as we might not use it somewhere else this is good enough for now.-->
  <div class="lightbox" *ngIf="lightboxOpen">
    <div class="lightbox-image">
      <i
        class="fal fa-chevron-left round-bg side-arrow side-arrow-left"
        *ngIf="images.length > 1"
        (click)="prevLightbox()"
      ></i>
      <i
        class="fal fa-chevron-right round-bg side-arrow side-arrow-right"
        *ngIf="images.length > 1"
        (click)="nextLightbox()"
      ></i>
      <img
        class="img-fluid w-100"
        [src]="
          [images[activeLightboxImage]]
            | productImageURL: settingNames.ProductImageLarge
        "
        [alt]="product.sku"
        vwProductImageFallback
      />
    </div>

    <div class="lightbox-caption">
      <div class="text">
        <span class="caption" *ngIf="product.media != null">
          {{
            product.media
              | media: mediaCategoryTypeNames.ProductName : mediaTypes.Text
          }}</span
        >
        <span class="paging-info" *ngIf="images.length > 0">
          {{
            "imageCarousel.pictureXOfY"
              | translate: { x: activeLightboxImage + 1, y: images.length }
          }}
        </span>
      </div>

      <div class="toggle">
        <i class="fal fa-times" (click)="toggleLightbox()"></i>
      </div>
    </div>
  </div>

  <div
    class="lightbox-overlay"
    *ngIf="lightboxOpen"
    (click)="toggleLightbox()"
  ></div>
</div>
